<script>
  import { modal, tabs, tab } from 'vue-strap';
  import Vue from 'vue';
  import FileInput from '~componentes/InputFile.vue'
  import converterObjetoFormData from '~js/converter-objeto-formdata';
  import solicitacaoPagamentoServico from '~modulos/solicitacao-pagamento/servico';
  import solicitacaoAdiantamentoServico from '~modulos/solicitacao-adiantamento/servico';
  import solicitacaoBolsaServico from '~modulos/solicitacao-bolsa/servico';
  import solicitacaoCompraServico from '~modulos/solicitacao-compra/servico';
  import pesquisaPrecoServico from '~modulos/aprovar-pesquisa-preco/servico';
  import solicitacaoFaturamentoServico from '~modulos/solicitacao-faturamento/servico';
  import solicitacaoFaturamentoMultiservicosServico from '~modulos/solicitacao-faturamento-multiservicos/servico';
  import solicitacaoReembolsoServico from '~modulos/solicitacao-reembolso/servico';
  import solicitacaoReembolsoTerceiroServico from '~modulos/solicitacao-reembolso-terceiro/servico';
  import acompanhamentoProjeto from '~modulos/acompanhamento-projeto/servico';
  import solicitacaoCursoEventoServico from '~modulos/solicitacao-curso-evento-servico/servico';
  import solicitacaoBolsaAtividadeServico from '~modulos/solicitacao-bolsa-atividades/servico';
  import solicitacaoImportacaoServico from '~modulos/solicitacao-importacao/servico';
  import solicitacaoTransferenciaServico from '~modulos/solicitacao-transferencia/servico';
  import solicitacaoCancelamentoContratoServico from '~modulos/solicitacao-cancelamento-contrato/servico';
  import solicitacaoContratacaoPessoal from '~modulos/solicitacao-contratacao-pessoal/servico';
  import inscricaoServico from '~modulos/acessos/servico.js';
  import pedidoServico from '~modulos/pedido/servico.js';
  
  import protocoloServico from '~modulos/protocolo/servico';

  export default {
    components: { modal, tabs, tab, FileInput },
    props: {
      mostrar: {
        type: Boolean,
        required: true,
      },
      tipo: {
        type: String,
        required: true,
      },
      id: {
        required: true,
      },
      idProtocolo: {
        type: String,
      }
    },
    data() {
      return {
        arquivos: [],
        arquivosInterno: new Array(5),
        carregando: true,
        fazendoUpload: false,
        possuiArquivoSol : false,
        mostrarDropzone: true,
      }
    },
    methods: {
      url() {
        let solicitacao = '';

        if (this.tipo === 'pagamento') {
          solicitacao = 'solicitacaopagamentos';
        } else if (this.tipo === 'compra') {
          solicitacao = 'solicitacaocompras';
        } else if (this.tipo === 'bolsa') {
          solicitacao = 'solicitacaobolsas';
        } else if (this.tipo === 'adiantamento') {
          solicitacao = 'solicitacaoadiantamentos';
        } else if (this.tipo === 'faturamento') {
          solicitacao = 'solicitacaofaturamentos';
        } else if (this.tipo === 'faturamento-multiservicos') {
          solicitacao = 'solicitacaofaturamentomultiservicos';
        } else if (this.tipo === 'reembolso') {
          solicitacao = 'solicitacaoreembolsos';
        } else if (this.tipo === 'reembolso-terceiro') {
          solicitacao = 'solicitacaoreembolsoterceiro';
        } else if (this.tipo === 'reembolso-terceiro') {
          solicitacao = 'solicitacaoreembolsoterceiro';
        } else if (this.tipo === 'acompanhamento') {
          solicitacao = 'acompanhamentoprojeto';
        } else if (this.tipo === 'cursoeventoservico') {
          solicitacao = 'solicitacaoCursoEventoServico';
        } else if (this.tipo === 'atividadecontrato') {
          solicitacao = 'solicitacaobolsas/atividade';
        } else if (this.tipo === 'importacao') {
          solicitacao = 'solicitacaoimportacao';
        } else if (this.tipo === 'transferencia') {
          solicitacao = 'solicitacaotransferencia';
        } else if (this.tipo === 'cancelamentocontrato') {
          solicitacao = 'solicitacaocancelamentocontrato';
        } else if (this.tipo === 'contratacao-pessoal') {
          solicitacao = 'solicitacaoContratacaoPessoal';
        } else if (this.tipo === 'inscricao') {
          return `/api/acessos/${this.id}/inscricao/arquivos`;
        } else if(this.tipo === 'pedido') {
          solicitacao = 'pedido';
        }

        return `/api/${solicitacao}/${this.id}/arquivos`;
      },
      lista() {
        let promise = null;
        this.carregando = false;

        if (this.tipo === 'pagamento') {
          promise = solicitacaoPagamentoServico.arquivos(this.id);
        } else if (this.tipo === 'compra') {
          promise = solicitacaoCompraServico.arquivos(this.id);
        } else if (this.tipo === 'pesquisapreco') {
          promise = pesquisaPrecoServico.arquivos(this.id);
        } else if (this.tipo === 'bolsa') {
          promise = solicitacaoBolsaServico.arquivos(this.id);
        } else if (this.tipo === 'adiantamento') {
          promise = solicitacaoAdiantamentoServico.arquivos(this.id);
        } else if (this.tipo === 'faturamento') {
          promise = solicitacaoFaturamentoServico.arquivos(this.id);
        } else if (this.tipo === 'faturamento-multiservicos') {
          promise = solicitacaoFaturamentoMultiservicosServico.arquivos(this.id);
        } else if (this.tipo === 'reembolso') {
          promise = solicitacaoReembolsoServico.arquivos(this.id);
        } else if (this.tipo === 'reembolso-terceiro') {
          promise = solicitacaoReembolsoTerceiroServico.arquivos(this.id);
        } else if (this.tipo === 'acompanhamento') {
          promise = acompanhamentoProjeto.arquivos(this.id);
        } else if (this.tipo === 'cursoeventoservico') {
          promise = solicitacaoCursoEventoServico.arquivos(this.id);
        } else if (this.tipo === 'atividadecontrato') {
          promise = solicitacaoBolsaAtividadeServico.arquivos(this.id);
        } else if (this.tipo === 'importacao') {
          promise = solicitacaoImportacaoServico.arquivos(this.id);
        } else if (this.tipo === 'transferencia') {
          promise = solicitacaoTransferenciaServico.arquivos(this.id);
        } else if (this.tipo === 'cancelamentocontrato') {
          promise = solicitacaoCancelamentoContratoServico.arquivos(this.id);
        } else if (this.tipo === 'contratacao-pessoal') {
          promise = solicitacaoContratacaoPessoal.arquivos(this.id);
        } else if (this.tipo === 'inscricao') {
          promise = inscricaoServico.arquivos(this.id, true);
        } else if (this.tipo === 'pedido') {
          promise = pedidoServico.arquivos(this.id);
        }

        promise
          .then(arquivos => {
            this.arquivos = arquivos;
            this.possuiArquivoSol = (arquivos.length > 0); 
            this.carregando = false;
          })
      },
      enviarArquivo() {
        $('#upload').button('loading');
        this.fazendoUpload = true;

        if (!this.existeArquivo()) {
          toastr.warning('É necessário anexar pelo menos um arquivo ');

          $('#upload').button('reset');
          this.fazendoUpload = false;

          return;
        }

        var arquivos = this.arquivosInterno;

        arquivos = converterObjetoFormData(arquivos);

        Vue.http.post(this.url(), arquivos)
          .then(res => res.data.id)
          .then(arquivo => {
            this.carregar();
            toastr.success('Arquivo(s) salvo(s) com sucesso. Verificar na aba "Arquivos".');
          })
          .catch(erro => {
            $('#upload').button('reset');
            this.fazendoUpload = false;
            toastr.error('Ocorreu um erro ao fazer upload de arquivo. ');
          });
      },
      download(arquivo) {
        arquivo = this.nomeArquivo(arquivo)
        let promise = null;

        if (arquivo.indexOf("_PROTOCOLO") === -1) {
          if (this.tipo === 'pagamento') {
            promise = solicitacaoPagamentoServico.download(this.id, arquivo);
          } else if (this.tipo === 'compra') {
            promise = solicitacaoCompraServico.download(this.id, arquivo);
          } else if (this.tipo === 'pesquisapreco') {
            promise = pesquisaPrecoServico.download(this.id, arquivo);
          } else if (this.tipo === 'bolsa') {
            promise = solicitacaoBolsaServico.download(this.id, arquivo);
          } else if (this.tipo === 'adiantamento') {
            promise = solicitacaoAdiantamentoServico.download(this.id, arquivo);
          } else if (this.tipo === 'faturamento') {
            promise = solicitacaoFaturamentoServico.download(this.id, arquivo);
          } else if (this.tipo === 'faturamento-multiservicos') {
            promise = solicitacaoFaturamentoMultiservicosServico.download(this.id, arquivo);
          } else if (this.tipo === 'reembolso') {
            promise = solicitacaoReembolsoServico.download(this.id, arquivo);
          } else if (this.tipo === 'reembolso-terceiro') {
            promise = solicitacaoReembolsoTerceiroServico.download(this.id, arquivo);
          } else if (this.tipo === 'acompanhamento') {
            promise = acompanhamentoProjeto.download(this.id, arquivo);
          } else if (this.tipo === 'cursoeventoservico') {
            promise = solicitacaoCursoEventoServico.download(this.id, arquivo);
          } else if (this.tipo === 'atividadecontrato') {
            promise = solicitacaoBolsaAtividadeServico.download(this.id, arquivo);
          } else if (this.tipo === 'importacao') {
            promise = solicitacaoImportacaoServico.download(this.id, arquivo);
          } else if (this.tipo === 'transferencia') {
            promise = solicitacaoTransferenciaServico.download(this.id, arquivo);
          } else if (this.tipo === 'cancelamentocontrato') {
            promise = solicitacaoCancelamentoContratoServico.download(this.id, arquivo);
          } else if (this.tipo === 'contratacao-pessoal') {
            promise = solicitacaoContratacaoPessoal.download(this.id, arquivo);
          } else if (this.tipo === 'inscricao') {
            promise = inscricaoServico.download(this.id, arquivo);
          } else if (this.tipo === 'pedido') {
            promise = pedidoServico.download(this.id, arquivo);
          }
        } else {
           promise = protocoloServico.download(this.idProtocolo, arquivo.replace("_PROTOCOLO", ""));
        }

        promise
          .then(arquivo => {
            arquivo.download();
          });
      },
      protocolo() {
        let promise = null;
        
        if (this.idProtocolo) {
          promise = protocoloServico.arquivos(this.idProtocolo);

          promise
          .then(arquivos => {
            for (var i = 0; i < arquivos.length; i++) {
              arquivos[i] = arquivos[i] + '_PROTOCOLO';  
            }

            if (this.possuiArquivoSol)
              this.arquivos = this.arquivos.concat(arquivos);
            else
              this.arquivos = arquivos;
          })
        }
      },
      carregar() {
        this.lista();
        this.protocolo();
        this.mostrarDropzone = this.tipo === 'pesquisapreco' ? false : true;
        this.limparArquivos();
        this.arquivosInterno = new Array(5);
        this.fazendoUpload = false;
        $('#upload').button('reset');
      },
      retornaTipoTexto() {
        let solicitacao = '';

        if (this.tipo === 'acompanhamento') {
          solicitacao = ' do acompanhamento projeto ';
        } else if (this.tipo === 'inscricao') {
          solicitacao = ' da inscrição';
        } else if(this.tipo === 'pedido') {
          solicitacao = ' do pedido';
        } else {
          solicitacao = ' da solicitação';
        }

        return solicitacao;
      },
      nomeArquivo(arquivo) {
        return arquivo.slice(arquivo.lastIndexOf('\\') + 1);
      },
      adicionarArquivo() {
        this.arquivosInterno.push(null);
      },
      limparArquivos() {
        this.deletados = [];

        while (this.arquivosInterno.length != 0) {
          this.arquivosInterno.pop();
        }

        for (var i = 0; i < 5; i++) {
          this.adicionarArquivo();
          this.$refs.fileInput[i].removerArquivo();
        }
      },
      existeArquivo() {
        let existeArquivo = false;
        for (let arquivo of this.arquivosInterno) {
          if (arquivo) {
            existeArquivo = true;
            break;
          }
        }
        return existeArquivo;
      },
      emitChanges() {

        let a = []
        for (let arquivo of this.arquivosInterno) {
          if (arquivo) {
            a.push(arquivo.name)
          }
        }
        this.$emit('input', a);
      },
    },
    computed: {
      show() {
        return this.mostrar;
      },
    },
    mounted() {
      this.mostrarDropzone = this.tipo === 'pesquisapreco' ? false : true;
    }
  }
</script>

<template>
  <div>

    <modal ref="modal"
           :value="show"
           effect="fade"
           @closed="mostrarDropzone = false, arquivos = [], limparArquivos(), $emit('fechado')"
           @opened="carregar"
           :large="true">
      <div slot="modal-header" class="modal-header">Arquivos {{ this.retornaTipoTexto() }} #{{ id }}</div>

      <tabs :nav-style="'tabs'" :justified="true">
        <tab header="Arquivos">

          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Nome do arquivo</th>
                  <th>Download</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="arquivo in arquivos">
                  <td>{{ nomeArquivo(arquivo.replace("_PROTOCOLO", "")) }}</td>
                  <td class="action">
                    <button type="button"
                            class="btn btn-default btn-xs"
                            @click="download(arquivo)">
                      <i class="fa fa-download"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="arquivos.length === 0 && !carregando">
                  <td colspan="2" class="text-center">Nenhum arquivo encontrado.</td>
                </tr>
                <tr v-show="carregando">
                  <td colspan="2">
                    <i class='fa fa-spinner fa-pulse'></i> Carregando...
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </tab>

        <tab header="Adicionar arquivos" v-show="mostrarDropzone">
          <div>
           
            <template v-for="(arquivo, indice) in arquivosInterno" >
              <file-input v-model="arquivosInterno[indice]" @input="emitChanges()" ref="fileInput"></file-input>
            </template>

            <div>
              <div class="hr-line-dashed margin-top-20"></div>
            </div>

            <div style="display:flex; justify-content: right; margin-top: 25px;">
              <button type="button" class="btn btn-success" @click="adicionarArquivo" style="margin-right: 10px;" v-show="!fazendoUpload">
                <i class="fa fa-plus"></i> Adicionar mais arquivos
              </button>

              <button type="button" class="btn btn-primary" @click="enviarArquivo" id="upload">
                <i class="fa fa-cloud-upload"></i> Upload
              </button>
            </div>
          </div>  
        </tab>
      </tabs>

      <div slot="modal-footer" class="modal-footer">
        <button type="button"
                class="btn btn-default"
                @click="$refs.modal.action(false, 3)">
          <i class="fa fa-times"></i> Fechar
        </button>
      </div>
    </modal>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/componentes/ModalArquivosSolicitacao.vue